import clsx from 'clsx'

interface Props {
  className?: string
  onClick: () => void
}

const CloseButton = ({className, onClick}: Props) => {
  return (
    <button className={clsx('p-3', className)} onClick={() => onClick()}>
      <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='a' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
          <path fill='#D9D9D9' d='M0 0h24v24H0z' />
        </mask>
        <g mask='url(#a)'>
          <path
            d='M6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19Z'
            fill='#fff'
          />
        </g>
      </svg>
    </button>
  )
}

export default CloseButton
